import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { useRouter } from "vue-router";
import { defineComponent, getCurrentInstance, toRefs, reactive, nextTick, watch } from "vue";
import { useStore } from "@/store/index";
import { joinParams } from "@/utils/index";
import Keys from "@/constant/key";
import { VueDraggableNext } from "vue-draggable-next";
import Pagination from "@/components/Pagination";
import { ElMessage } from "element-plus";
import { fileUpload } from "@/utils/upload";
import { Plus, Delete } from "@element-plus/icons-vue";
import { ShipTypes } from "@/enums/order";
import { getLastMonthToday, getCurrentDate } from '@/utils/index';
export default defineComponent({
  name: "OneSettlementList",
  components: {
    Pagination,
    Plus,
    Delete,
    draggable: VueDraggableNext
  },
  setup() {
    const {
      proxy
    } = getCurrentInstance();
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const today = new Date();
    const currentTimeString = `${today.getHours().toString().padStart(2, '0')}:${today.getMinutes().toString().padStart(2, '0')}:${today.getSeconds().toString().padStart(2, '0')}`;
    const state = reactive({
      srcList: [],
      o: route.query.o || null,
      filters: {
        status: "",
        tmp_secondary_id: [],
        receipt_pay_start: "",
        receipt_pay_end: "",
        order_no: "",
        phone: "",
        receipt_status: 0,
        start_date: route.query.start_date || `${getLastMonthToday()} ${currentTimeString}`,
        end_date: route.query.end_date || `${getCurrentDate()} ${currentTimeString}`,
        receipt_date: "",
        timeClick: "",
        brand_id: "",
        limit: 10,
        page: 1,
        is_export: 0
      },
      tableData: [],
      isLoading: false,
      // 表格数据加载状态
      shopUserList: [],
      spanArr: null,
      pos: 0,
      count: 0,
      dialogTitle: "",
      isCopied: false,
      dialogVisible: false,
      settlementOptions: {
        receipt_amount: "",
        receipt_pay_date: "",
        receipt_node: "",
        poster: [],
        brand_name: "",
        order_no: "",
        act_clearing_newprice: "",
        pay_vouther_no: "",
        invoice_img_list: [],
        receipt_pay_nos: "",
        receipt_img_data: []
      },
      MultipleList: [],
      type: 1,
      totalSettlementAmount: 0,
      MultipleBtn: false,
      order_count: 0,
      mainPreviewList: [],
      invoicePreviewList: [],
      currentorder: {},
      brandName: "",
      editStatus: false,
      flag: false,
      receipt_img_data: [],
      stash_poster_data: [],
      handleSizeChange(val) {
        state.filters.limit = val;
        state.MultipleBtn = false;
        state.getList();
      },
      handleCurrentChange(val) {
        state.filters.page = val;
        state.MultipleBtn = false;
        state.getList();
      },
      getList() {
        // state.isLoading = true
        proxy.$http.get(`/admin/brands/get_ydyj_order_list?${joinParams(state.filters)}`).then(res => {
          const {
            code,
            data,
            msg
          } = res;
          if (code != 200) {
            state.tableData = [];
            state.count = 0;
            state.isLoading = false;
            return proxy.$message({
              type: "error",
              message: res.msg
            });
          }
          state.tableData = data.data;
          state.spanArr = data.data;
          state.count = data.total;
          state.getSpanArr(state.spanArr);
          state.srcList = ["https://img.dangaoss.com/public/p/72/0/1176489_l.jpg"];
          state.isLoading = false;
        });
      },
      search(type) {
        if (type) {
          state.filters.start_date = "";
          state.filters.end_date = "";
        }
        state.filters.page = 1;
        state.getList();
      },
      output() {
        window.open(`${Keys.baseUrl}/admin/brands/get_ydyj_order_list?${joinParams({
          ...state.filters,
          is_export: 1,
          user_id: store.state.user.userInfo.id
        })}`);
      },
      selectmonth() {
        state.filters.page = 1;
        state.getList();
        const params = {
          brand_id: state.filters.brand_id,
          start_date: state.filters.start_date,
          end_date: state.filters.end_date,
          user_id: store.state.user.userInfo.id,
          user_name: store.state.user.userInfo.username
        };
        proxy.$http.get('/admin/brands/get_ydyj_amount', params).then(res => {
          const {
            code,
            data,
            msg
          } = res;
          if (code != 200) {
            return proxy.$message({
              type: 'error',
              message: msg
            });
          }
          if (data.order_nums > 0) {
            state.settlementOptions.brand_name = data.brand_name;
            state.currentorder.order_id = data.order_str;
            state.currentorder.order_str = data.order_str;
            state.order_count = data.order_nums;
            state.totalSettlementAmount = data.order_clearing_price;
            state.type = 2;
            state.dialogTitle = "批量处理";
            state.dialogVisible = true;
          } else {
            proxy.$message({
              type: "error",
              message: "没有可结算的订单"
            });
          }
        });
      },
      getShopList: () => {
        proxy.$http.get(`/admin/brands/get_ydyj_brand_list?user_id=${store.state.user.userInfo.id}$user_name=${store.state.user.userInfo.username}`).then(res => {
          if (res.code == 200) {
            state.shopUserList = res.data;
          } else {
            state.shopUserList = [];
          }
        });
      },
      getSpanArr: resData => {
        state.spanArr = [];
        if (resData === null) {
          return;
        }
        for (let i = 0; i < resData.length; i++) {
          if (i === 0) {
            state.spanArr.push(1);
            state.pos = 0;
          } else {
            if (resData[i].order_id === resData[i - 1].order_id) {
              state.spanArr[state.pos] += 1;
              state.spanArr.push(0);
            } else {
              resData[i].hasClass = true;
              state.spanArr.push(1);
              state.pos = i;
            }
          }
        }
      },
      objectSpanMethod: ({
        row,
        column,
        rowIndex,
        columnIndex
      }) => {
        let columnArray = [0, 1, 4, 5, 6, 9, 11, 12, 13, 14, 15, 16, 17];
        if (columnArray.includes(columnIndex)) {
          const _row = state.spanArr[rowIndex];
          const _col = _row > 0 ? 1 : 0;
          return {
            rowspan: _row,
            colspan: _col
          };
        }
      },
      copyRow: async row => {
        const chargeInfoDetails = row.order_charge.length > 0 ? row.order_charge.map(charge => {
          return `
                    名称：${charge.charge_name || "无"}
                    单价 / 数量：${charge.price && charge.quantity ? charge.price + "/" + charge.quantity : "无"}
                    金额：${charge.total_amount || "无"}
                    `;
        }).join("\n") : "暂无收费信息";
        const textToCopy = ` 
                收货人姓名：${row.name || "无"}
                收货人电话：${row.phone || "无"}
                下单人电话：${row.buyer_phone || "无"}
                配送方式：${row.ship_type || "无"}
                配送时间：${ShipTypes[row.ship_type] || "无"}
                收货人地址：${row.city}${row.area}${row.addr}
                用户备注：${row.buyer_msg || "无"}
                订单号：${row.order_no || "无"}
                额外配件费：${row.delivery_fee || "无"}
                附件结算价：
                商品信息：
                        商品名称：${row.product_name || "无"}
                        规格：${row.spec_name || "无"}
                        口味：${row.tastes || "无"}
                        单价：${row.price || "无"}
                        数量：${row.quantity || "无"}   
                        商品金额：${row.price && row.quantity ? (parseFloat(row.price) * parseFloat(row.quantity)).toFixed(2) : "无"}
                        结算单价：${row.act_clearing_price || "无"}
                        罚款金额：${row.fine_money || "无"}
                        罚款时间：${row.fine_time || "无"}
                        罚款原因：${row.fine_reason || "无"}
                收费附件：${chargeInfoDetails}`;
        try {
          await navigator.clipboard.writeText(textToCopy);
          ElMessage.success("复制成功");
          state.isCopied = true;
          setTimeout(() => {
            state.isCopied = false;
          }, 3000);
        } catch (err) {
          ElMessage.error("复制失败");
        }
      },
      settlement: (row, type) => {
        state.type = type;
        if (type == 1) {
          state.currentorder = row;
          state.order_count = 0;
          state.settlementOptions.brand_name = row.brand_name;
          state.settlementOptions.order_no = row.order_no;
          state.settlementOptions.act_clearing_newprice = row.act_clearing_newprice;
          state.dialogTitle = "上传结算凭证";
          state.stash_poster_data = [];
          if (row.receipt_status == 1) {
            state.dialogTitle = "查看结算凭证";
            state.stash_poster_data = row.receipt_img_data;
            state.settlementOptions = {
              ...state.settlementOptions,
              ...row,
              poster: row.receipt_img_url ? row.receipt_img_url.split(",").map(url => ({
                url: url,
                uid: Date.now() + Math.floor(Math.random() * 1000)
              })) : [],
              invoice_img_list: row.invoice_img ? row.invoice_img.split(",").map(url => ({
                url: url,
                uid: Date.now() + Math.floor(Math.random() * 1000),
                type: url.split(".").pop(),
                file_name: url.split("/").pop()
              })) : []
            };
            state.mainPreviewList = state.settlementOptions.poster.map(item => item.url);
            state.invoicePreviewList = state.settlementOptions.invoice_img_list.map(item => item.url);
          }
        } else {
          state.stash_poster_data = [];
          state.settlementOptions.brand_name = row.length ? row[0].brand_name : "";
          state.dialogTitle = "批量处理";
          if (row.length == 0) return ElMessage.error("请选择同商家未结算订单");
          state.currentorder.order_id = row.map(item => item.order_id).join(",") || "";
        }
        state.dialogVisible = true;
        nextTick(() => {
          if (state.dialogTitle === "查看结算凭证" && proxy.$refs["receiptForm"]) {
            proxy.$refs["receiptForm"].clearValidate();
          }
        });
      },
      poster_img(param) {
        state.uploadPosterRequest(param, 1);
      },
      invoice_img(param) {
        state.uploadPosterRequest(param, 2);
      },
      uploadPosterRequest: async (param, type) => {
        const {
          code,
          data,
          msg
        } = await fileUpload(param.file, {
          folderName: "settlement"
        });
        if (code != 200) {
          return proxy.$message({
            type: "error",
            message: msg
          });
        }
        if (type == 1) {
          // 请求凭证识别
          const voutherData = await proxy.$http.post("/admin/invoice/get_vouther_datas", {
            url: data.url
          });
          if (voutherData.code != 200) {
            return proxy.$message({
              type: "error",
              message: voutherData.msg
            });
          }
          state.settlementOptions.poster.push({
            id: data.uid,
            url: data.url
          });
          const {
            pay_vouther_no,
            pay_amount,
            pay_time
          } = voutherData.data;
          // 上传
          state.stash_poster_data.push({
            id: data.uid,
            url: data.url,
            pay_vouther_no: pay_vouther_no,
            pay_amount: pay_amount,
            pay_time: pay_time
          });
          state.settlementOptions.receipt_pay_nos = state.stash_poster_data.length > 0 ? state.stash_poster_data.map(item => item.pay_vouther_no).join(",") : "";
          state.settlementOptions.receipt_amount = pay_amount;
          state.settlementOptions.receipt_pay_date = pay_time;
          nextTick(() => {
            if (proxy.$refs["receiptForm"]) {
              proxy.$refs["receiptForm"].validateField("receipt_pay_date");
            }
          });
        } else {
          // 请求发票识别
          const invoiceData = await proxy.$http.post("/invoice/getInvoiceData", {
            invoice_img: data.url
          });
          if (invoiceData.code != 200) {
            return proxy.$message({
              type: "error",
              message: invoiceData.msg
            });
          }
          state.settlementOptions.invoice_img_list.push({
            id: data.uid,
            url: data.url,
            file_name: data.file_name,
            type: data.url.split(".").pop()
          });
        }
      },
      onSelectionChange: val => {
        state.MultipleBtn = false;
        state.MultipleList = val;
        const brandNames = val.map(item => item.brand_name);
        const uniqueBrandNames = new Set(brandNames);
        if (val.length > 0 && uniqueBrandNames.size > 1) {
          state.MultipleBtn = true;
          nextTick(() => {
            proxy.$refs.multipleTable.clearSelection();
          });
          return ElMessage.error("请选择同商家未结算订单");
        }
        if (val.length > 0) {
          state.order_count = val.length;
          state.totalSettlementAmount = val.reduce((acc, cur) => acc + Number(cur.act_clearing_newprice), 0).toFixed(2);
          state.currentorder.order_id = val.map(item => item.order_no).join(",");
        }
        if (val.length == 1) {
          state.brandName = val[0].brand_name;
        }
      },
      onSelectAll: val => {
        if (val.length == 0) {
          state.flag = !state.flag;
          if (state.flag) {
            state.MultipleBtn = true;
            return ElMessage.error("本页无未结算订单");
          } else {
            state.MultipleBtn = false;
          }
        }
      },
      checkSelectable(row, index) {
        if (row.receipt_status === 1) {
          return false;
        }
        if (state.MultipleList.length === 0) {
          return true;
        }
        const selectedBrand = state.MultipleList[0].brand_name;
        return row.brand_name === selectedBrand;
      },
      submit(type) {
        const {
          receipt_amount,
          act_clearing_newprice,
          receipt_node,
          poster
        } = state.settlementOptions;
        if (poster.length == 0) {
          return proxy.$message({
            type: "error",
            message: "请上传付款截图"
          });
        }
        if (state.dialogTitle) {
          if (state.order_count > 0 && Number(receipt_amount) !== Number(state.totalSettlementAmount)) {
            if (!receipt_node) {
              return proxy.$message({
                type: "error",
                message: "付款金额与结算金额不一致，请修改"
              });
            }
          }
          if (Number(receipt_amount) !== Number(act_clearing_newprice)) {
            if (!receipt_node) {
              return proxy.$message({
                type: "error",
                message: "付款金额与结算金额不一致，请输入备注信息"
              });
            }
          }
        }
        const payVoutherNos = state.stash_poster_data.map(item => item.pay_vouther_no);
        const hasDuplicates = new Set(payVoutherNos).size !== payVoutherNos.length;
        if (hasDuplicates) return proxy.$message({
          type: "error",
          message: "存在重复付款凭证，请重新上传"
        });
        proxy.$refs["receiptForm"].validate(valid => {
          if (valid) {
            const invoice_img = invoicePreviewList.value.length > 0 ? invoicePreviewList.value.map(item => item).join(",") : "";
            const poster_img = mainPreviewList.value.length > 0 ? mainPreviewList.value.map(item => item).join(",") : "";
            const filters = {
              ...state.settlementOptions,
              order_id: state.dialogTitle !== "查看结算凭证" ? state.currentorder.order_id : state.settlementOptions.order_str,
              brand_name: state.settlementOptions.brand_name,
              order_nums: state.dialogTitle !== "查看结算凭证" ? state.order_count > 0 ? state.order_count : 1 : state.settlementOptions.order_nums,
              clearing_total_amount: state.dialogTitle !== "查看结算凭证" ? state.totalSettlementAmount : state.settlementOptions.clearing_total_amount,
              invoice_img: invoice_img,
              receipt_img_url: poster_img,
              clearing_amount: state.settlementOptions.act_clearing_newprice,
              type: type,
              receipt_img_data: state.stash_poster_data
            };
            proxy.$http.post('/admin/brands/do_order_receipt', filters).then(res => {
              const {
                code,
                data,
                error_msg,
                msg
              } = res;
              if (code != 200) {
                return proxy.$message({
                  type: "error",
                  message: error_msg || msg
                });
              } else {
                proxy.$message({
                  type: "success",
                  message: "结算成功"
                });
              }
              state.dialogVisible = false;
              state.editStatus = false;
              state.stash_poster_data = [];
              state.settlementOptions = {
                receipt_amount: "",
                receipt_node: "",
                receipt_pay_date: "",
                poster: [],
                invoice_img_list: [],
                brand_name: "",
                order_no: "",
                act_clearing_newprice: "",
                pay_vouther_no: "",
                invoice_img_list: [],
                receipt_pay_nos: "",
                receipt_img_data: []
              };
              state.getList();
            });
          }
        });
      },
      edit() {
        state.editStatus = true;
      },
      onImgRemove: (index, type) => {
        proxy.$confirm("确定要删除该图片？", "提示", {
          type: "warning"
        }).then(() => {
          if (type == 1) {
            let targetUrl = state.settlementOptions.poster[index].url;
            const {
              mainPreviewList
            } = state;
            const {
              poster
            } = state.settlementOptions;
            mainPreviewList.splice(index, 1);
            poster.splice(index, 1);
            state.settlementOptions.poster = poster;
            state.mainPreviewList = mainPreviewList;
            // 订单号处理
            state.receipt_img_data = state.stash_poster_data.filter(item => {
              return item.url !== targetUrl;
            });
            state.stash_poster_data = state.receipt_img_data;
            state.settlementOptions.receipt_pay_nos = state.receipt_img_data.length > 0 ? state.receipt_img_data.map(item => item.pay_vouther_no).join(",") : "";
          } else {
            const {
              invoicePreviewList
            } = state;
            const {
              invoice_img_list
            } = state.settlementOptions;
            invoicePreviewList.splice(index, 1);
            invoice_img_list.splice(index, 1);
            state.settlementOptions.invoice_img_list = invoice_img_list;
            state.invoicePreviewList = invoicePreviewList;
          }
        }).catch(() => {
          console.log("取消删除");
        });
      },
      onDialogClose() {
        state.dialogVisible = false;
        state.settlementOptions = {
          receipt_amount: "",
          receipt_node: "",
          receipt_pay_date: "",
          poster: [],
          invoice_img_list: [],
          brand_name: "",
          order_no: "",
          act_clearing_newprice: "",
          pay_vouther_no: "",
          invoice_img_list: [],
          receipt_pay_nos: "",
          receipt_img_data: []
        };
        state.editStatus = false;
        state.stash_poster_data = [];
        state.receipt_img_data = [];
      },
      handleDialogOpened() {
        // 如果是查看模式，清除验证状态
        if (state.dialogTitle === "查看结算凭证") {
          nextTick(() => {
            if (proxy.$refs["receiptForm"]) {
              proxy.$refs["receiptForm"].clearValidate();
            }
          });
        }
      }
    });
    watch(() => state.settlementOptions.poster, newPoster => {
      if (!newPoster || newPoster.length === 0) {
        state.settlementOptions.receipt_amount = "";
        state.settlementOptions.receipt_pay_date = "";
        state.settlementOptions.receipt_pay_nos = "";
        state.settlementOptions.receipt_node = "";
        state.stash_poster_data = [];
        state.receipt_img_data = [];
      }
    }, {
      deep: true,
      immediate: false
    });
    const setTableHeight = () => {
      nextTick(() => {
        let headerHeight = 50,
          filterHeight = proxy.$refs.filterContainer.offsetHeight + 30,
          paginationHeight = 62;
        state.tableHeight = window.innerHeight - headerHeight - filterHeight - paginationHeight;
      });
    };
    const disableFutureDates = date => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date.getTime() > today.getTime();
    };
    const mainPreviewList = computed(() => {
      const {
        poster
      } = state.settlementOptions;
      let tmpArr = poster.map(item => {
        // @ts-ignore
        if ((item.id || item.uid) && item.url) {
          var _item$url;
          // @ts-ignore
          return (_item$url = item.url) === null || _item$url === void 0 || (_item$url = _item$url.replace("?x-oss-process=style/s_img_160", "")) === null || _item$url === void 0 ? void 0 : _item$url.replace("_s.jpg", ".jpg");
        }
      });
      state.mainPreviewList = tmpArr;
      return tmpArr;
    });
    const invoicePreviewList = computed(() => {
      const {
        invoice_img_list
      } = state.settlementOptions;
      let tmpArr = invoice_img_list.map(item => {
        // @ts-ignore
        if ((item.id || item.uid) && item.url) {
          var _item$url2;
          // @ts-ignore
          return (_item$url2 = item.url) === null || _item$url2 === void 0 || (_item$url2 = _item$url2.replace("?x-oss-process=style/s_img_160", "")) === null || _item$url2 === void 0 ? void 0 : _item$url2.replace("_s.jpg", ".jpg");
        }
      });
      state.invoicePreviewList = tmpArr;
      return tmpArr;
    });
    const invoiceImgList = computed(() => {
      const {
        invoice_img_list
      } = state.settlementOptions;
      let tmpArr = invoice_img_list.map(item => {
        const type = item.type || item.url.split(".").pop();
        if (["jpg", "jpeg", "png", "gif"].includes(type.toLowerCase())) {
          // @ts-ignore
          if ((item.id || item.uid) && item.url) {
            var _item$url3;
            // @ts-ignore
            return (_item$url3 = item.url) === null || _item$url3 === void 0 || (_item$url3 = _item$url3.replace("?x-oss-process=style/s_img_160", "")) === null || _item$url3 === void 0 ? void 0 : _item$url3.replace("_s.jpg", ".jpg");
          }
        }
      });
      state.invoicePreviewList = tmpArr;
      return tmpArr;
    });
    const validDelayTime = computed(() => {
      const {
        receipt_amount,
        act_clearing_newprice
      } = state.settlementOptions;
      const money = state.order_count > 0 ? Number(state.totalSettlementAmount) : Number(act_clearing_newprice);
      return Number(receipt_amount) !== money && state.dialogTitle !== "查看结算凭证";
    });
    const addSettlementFrom = reactive({
      poster: [{
        required: true,
        message: "",
        trigger: "change"
      }],
      receipt_amount: [{
        required: true,
        message: "请输入付款金额",
        trigger: "change"
      }],
      receipt_pay_date: [{
        required: true,
        message: "请输入付款时间",
        trigger: "change"
      }],
      receipt_node: [{
        required: validDelayTime,
        message: "请输入备注",
        trigger: "change"
      }]
    });
    // 设置 table 高度
    setTableHeight();
    // 监听窗口变化，重置 table 高度
    window.onresize = setTableHeight;
    state.getShopList();
    state.getList();
    return {
      ...toRefs(state),
      router,
      Keys,
      store,
      mainPreviewList,
      invoicePreviewList,
      addSettlementFrom,
      validDelayTime,
      disableFutureDates,
      invoiceImgList
    };
  }
});